import React from 'react';
import {ExclamationIcon} from '@heroicons/react/solid'

export default function ReadDocs() {
  return (
    <div style={{minHeight: '35em'}} >
      <div className="w-full mx-auto overflow-hidden">
        <p className="mt-5  max-w-3xl text-lg  text-gray-900">
          To become an oracle, you will need to deposit a set amount of tokens (TBD) and provide a URL that responds in a specific format.
        </p>
        <p  className=" mt-5  max-w-3xl text-lg  text-gray-900">
          To learn how to format your endpoint based on the feed you are submitting to, go through the official documentations.
        </p>
        <div className="rounded-md max-w-3xl mt-5 bg-yellow-50 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <ExclamationIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800">Attention</h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>
                  Ensure you have read and fully understood the documentation. As a decentralized system, providing poor or malicious feeds may result in losing a portion or all of your staked funds.
                </p>
              </div>
            </div>
          </div>
        </div>
        <p className="mt-5 text-lg    max-w-3xl text-gray-900">
          As a decentralized application, providing invalid, or malicious URLs will result in an irreversible loss of part or all of your funds.
        </p>
        <p className="mt-5 mb-10 text-lg    max-w-3xl text-gray-900">
          To learn more about how Goracle keeps the system safe, secure and rewarding for all participants, checkout the rewards page.
        </p>
        <h2><b>Interested in setting up feeds?</b></h2>
        <p className="mt-5 mb-20 text-lg   max-w-3xl text-gray-900">
          As we enter testnet, we are helping community member download and install the node software. If you are interested in running a node, <a style={{color: 'blue'}} href="https://www.goracle.io/contact"> get in touch with us.</a>
        </p>
      </div>
    </div>
  );
}
